import $ from 'jquery'
import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded from 'Imagesloaded'

export default {
  init() {
    const artist = new Swiper('.artist-swiper-container', {
      init: false,
      navigation: {
        nextEl: '.about-gallery-next',
        prevEl: '.about-gallery-prev',
      },
      loop: true,
      autoplay: {
        delay: 4000,
      },
      speed: 400,
      autoHeight: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
    });
    
    ImagesLoaded( '.artist-wrapper', ()=> {
      artist.init()
    })

  },
  finalize() {
  },
}
